import { exportsData, exceptionsData, standardsData, mediaData } from "./proxyData"

export function fetchExports() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ ...exportsData, ...exceptionsData })
    }, 500)
  })
}

export function fetchProxyStandards() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(standardsData)
    }, 200)
  })
}

export function fetchProxyMediaTypes() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mediaData)
    }, 200)
  })
}

//const standardsUrl =
//   "https://mmmr1ae7o2.execute-api.us-east-1.amazonaws.com/hmi-poc/factors/"

//const standardsUrl = "http://hmi-capone-restapi-dev.us-east-1.elasticbeanstalk.com/api/v0/reports/conversion_factor"

//const baseUrl = "https://woodstock.itdev.spire.horizonmedia.com"

const baseUrl = process.env.REACT_APP_BASE_URL
const standardsUrl = `${baseUrl}/api/v0/reports`
const usersUrl = `${baseUrl}/api/v0/users`

export function userLogin(email, password) {
  return fetch(`${usersUrl}/auth/login`, {
    method: "POST",
    body: JSON.stringify({ email, password }),
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  })
}

export async function fetchTable(user, table) {
  let options = { mode: "cors" }
  if (user) {
    options.headers = {
      Authorization: `Bearer ${user.token}`,
    }
  }
  return await fetch(`${standardsUrl}/${table}`, options)
}

export async function postToTable(user, table, opts) {
  let options = {
    method: "POST",
    body: JSON.stringify(opts),
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`,
    },
  }
  if (user) {
    options.headers["Authorization"] = `Bearer ${user.token}`
  }
  return await fetch(`${standardsUrl}/${table}`, options)
}

export async function patchTable(user, table, opts) {
  return await fetch(`${standardsUrl}/${table}/${opts.id}`, {
    method: "POST",
    body: JSON.stringify(opts),
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`,
    },
  })
}

export async function deleteFromTable(user, table, opts) {
  return await fetch(`${standardsUrl}/${table}/${opts.id}/delete`, {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({}),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`,
    },
  })
}

export async function getGetSignedUrl(user, folderName, mediaType, fileName) {
  let options = { mode: "cors" }
  if (user) {
    options.headers = { Authorization: `Bearer ${user.token}` }
  }
  const getUrl = `${baseUrl}/api/v0/reports/get-signed-url/${folderName}/${mediaType}/${fileName}`
  const response = await fetch(getUrl, options)
  let responseJSON = await response.json()
  return responseJSON
}

// const dateUrl = `${baseUrl}/latest_megafile`
// const latestMegafileDate = await fetch(dateUrl, { mode: "cors" })
// console.log('latestMegafileDate);

export async function getPutSignedUrl(user, mediaType, file) {
  let options = { mode: "cors" }
  if (user) {
    options.headers = { Authorization: `Bearer ${user.token}` }
  }
  const putUrl = `${baseUrl}/api/v0/reports/put-signed-url/${mediaType}/${file.name}`
  const response = await fetch(putUrl, options)
  let responseJSON = await response.json()
  return { ...responseJSON, file }
}

export async function getMegafileTime() {
  let options = { mode: "cors" }
  const dateUrl = `${baseUrl}/api/v0/reports/latest_megafile`
  const response = await fetch(dateUrl, options)
  let responseJSON = await response.json()
  let { created } = responseJSON
  return created
}

export async function putFileS3(signedUrl, file, fileType) {
  let options = {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": fileType,
    },
  }
  return await fetch(signedUrl, options)
}

export async function requestPostPurchByQuarter(user, query) {
  const getUrl = `${baseUrl}/api/v0/reports/requestpostpurchreport?ReportType=${query.ReportType}&PurchReportParam=${query.PurchReportParam}&PostReportParam=${query.PostReportParam}&ReportName=${query.ReportName}`
  const response = await fetch(getUrl, {
    mode: "cors",
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  })
  return await response
}

export async function fetchFile(
  url,
  filename = "template.xlsx",
  progressCallback,
  completionCallback,
  errorCallback
) {
  console.log(" URL TO FETCH ", url)
  fetch(url, {
    headers: {
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  })
    .then(async (response) => {
      if (response.status !== 200) {
        console.log("file not found")
        throw new Error("file not found")
      }
      // instead of response.json() and other methods
      const cloneBody = response.clone().body
      const reader = cloneBody.getReader()

      let totalDownloaded = 0
      const totalBytes = response.headers.get("Content-Length")

      // infinite loop while the body is downloading
      // eslint-disable-next-line no-constant-condition
      while (true) {
        // done is true for the last chunk
        // value is Uint8Array of the chunk bytes
        const { done, value } = await reader.read()

        if (done) {
          break
        }
        totalDownloaded += value.length

        progressCallback(Math.ceil((totalDownloaded / totalBytes) * 100))
      }
      return response
    })
    .then(async (response) => {
      return response.blob()
    })
    .then(async (blob) => {
      if (completionCallback) {
        completionCallback()
      }
      var url = window.URL.createObjectURL(blob)
      var a = document.createElement("a")
      a.href = url

      let fileTime
      if (filename === "capone_megafile.csv") {
        fileTime = await getMegafileTime()
      }

      a.download =
        filename === "capone_megafile.csv"
          ? `capone_megafile_${fileTime}.csv`
          : filename
      document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click()
      a.remove() //afterwards we remove the element again
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error)
      }
    })
  return
}

export async function exportTable(user, tablename) {
  const getUrl = `${baseUrl}/api/v0/reports/export/${tablename}`
  const response = await fetch(getUrl, {
    mode: "cors",
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  })
  let responseJSON = await response.json()
  return responseJSON
}

export async function parseToCSV(user, context, filename, label) {
  const getUrl =
    label === "Estimate Naming Convention"
      ? `${baseUrl}/api/v0/reports/saveXlsConvertToCsv/${context}/${filename}`
      : `${baseUrl}/api/v0/reports/parse/${context}/${filename}`
  const options = {
    mode: "cors",
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  }
  const response = await fetch(getUrl, options)

  return await response.json()
}

export async function saveParsed(user, fileType, qtrYear, csvLocation) {
  const getUrl = `${baseUrl}/api/v0/reports/saveParsed`
  let options = {
    method: "POST",
    body: JSON.stringify({ fileType, qtrYear, csvLocation }),
    mode: "cors",
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json",
    },
  }

  const response = await fetch(getUrl, options)

  return await response.json()
}

export async function validateCSVAndImport(user, csvLocation, xlsLocation) {
  const getUrl = `${baseUrl}/api/v0/reports/validateCSVAndImport`
  let options = {
    method: "POST",
    body: JSON.stringify({ csvLocation, xlsLocation }),
    mode: "cors",
    headers: {
      Authorization: `Bearer ${user.token}`,
      "Content-Type": "application/json",
    },
  }

  console.log(" >>>>>>>>>>>>>>>>>>>>>>>>  POST TO NEW API ", options)

  const response = await fetch(getUrl, options)

  return await response.json()
}

export async function requestMegafile(user) {
  const getUrl = `${baseUrl}/api/v0/reports/requestMegafileADHOC`
  const response = await fetch(getUrl, {
    mode: "cors",
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  })
  let responseJSON = await response.json()
  console.log("megafile response", responseJSON)
  return responseJSON
}
